import type { Archetype } from "./types.js";

export const ARCHETYPES: Archetype[] = [
  {
    k: ["cul", "nig"],
    name: "The Midnight Forager",
    desc: "You travel on *your stomach* and the city gets better *after dark*.",
  },
  {
    k: ["nature", "serene"],
    name: "The Slow River",
    desc: "Mist, mountains, and *nowhere to be*. You want China to unfold, not rush.",
  },
  {
    k: ["ancient", "city"],
    name: "The Time Traveler",
    desc: "Dynasties by day, skylines by night — you want the *whole 3,000-year arc*.",
  },
  {
    k: ["adv", "nature"],
    name: "The Cliff Walker",
    desc: "If there's a plank walk, *you're on it*. Landscapes should raise your pulse.",
  },
  {
    k: ["cul", "ancient"],
    name: "The Street Food Historian",
    desc: "Every noodle has *a dynasty behind it*, and you want both.",
  },
  {
    k: ["city", "electric"],
    name: "The Neon Drifter",
    desc: "Megacity energy — rooftops, river lights, *trains through buildings*.",
  },
  {
    k: ["hidden", "texture"],
    name: "The Backstreet Cartographer",
    desc: "You collect the streets *the guidebooks missed*.",
  },
  {
    k: ["cra", "ancient"],
    name: "The Apprentice",
    desc: "You don't want to see the tea ceremony. You want to pour.",
  },
  {
    k: ["spectacle", "iconic"],
    name: "The Postcard Hunter",
    desc: "The big vistas earned their fame. You're going to *all of them*.",
  },
];

/** Shown instead of a taste archetype when the trip includes kids. */
export const PACK_LEADER: Archetype = {
  name: "The Pack Leader",
  desc: "Everyone in the crew has to win — *pandas, castles, and easy days*.",
};
